import { GET_SELFIE_LIST } from "../../modules/constants";

export function getSelfieList(value) {
  return {
    type: GET_SELFIE_LIST,
    payload: value,
  };
}